export default "__VITE_ASSET__DE4Rl5N7__"